module.exports = __webpack_public_path__ + "static/innovation-and-entrepreneurship-3e534345c065c5c919acdf83d8435078.jpg";